import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#0f0f0f] bg-[#080808]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top — big CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row items-center justify-between gap-8 pb-14 border-b border-[#0f0f0f] mb-14"
        >
          <h2 className="font-serif text-[clamp(1.8rem,4vw,3.5rem)] text-white leading-tight max-w-xl">
            Ready to build something{' '}
            <span className="italic text-lime">extraordinary?</span>
          </h2>
          <a href="#contact" className="btn-lime px-8 py-4 text-sm flex-shrink-0">
            Let's Start →
          </a>
        </motion.div>

        {/* Links grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="SiteStackCo" className="h-10 w-auto object-contain" />
              <span className="font-syne font-bold text-white text-base">
                SiteStack<span className="text-lime">Co</span>
              </span>
            </div>
            <p className="font-dm text-[#888] text-sm leading-relaxed max-w-xs">
              Web Design · Branding · Creative Media. Helping small businesses build bold digital presences.
            </p>
            <div className="flex gap-3 mt-6">
              {['IG','FB','LI','TK'].map(s => (
                <a key={s} href="https://sitestackco.com" target="_blank" rel="noreferrer"
                  className="w-8 h-8 rounded-full border border-[#1a1a1a] flex items-center justify-center font-syne font-bold text-[#888] hover:border-lime hover:text-lime transition-all text-xs">
                  {s}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-syne font-bold text-white text-xs uppercase tracking-widest mb-5">Services</h4>
            <ul className="space-y-3">
              {['Web Design','Branding','Photography','Videography','Digital Marketing','Support Plans'].map(item => (
                <li key={item}>
                  <a href="#services" className="font-dm text-[#888] text-sm hover:text-lime transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-syne font-bold text-white text-xs uppercase tracking-widest mb-5">Company</h4>
            <ul className="space-y-3">
              {[['Why Us','#why-us'],['Our Mission','#mission'],['Recent Works','#works'],['Team','#team'],['Contact','#contact']].map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="font-dm text-[#888] text-sm hover:text-lime transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#0f0f0f] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-dm text-[#777] text-xs">© {year} SiteStackCo. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="/privacy" className="font-dm text-[#777] text-xs hover:text-lime transition-colors">Privacy Policy</a>
            <a href="/privacy" className="font-dm text-[#777] text-xs hover:text-lime transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
